import React, { useEffect, useRef, useState } from 'react';
import { Modal, Button, FormGroup, FormControl, ControlLabel, OverlayTrigger, Popover } from 'react-bootstrap';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import qs from 'qs';

import Spinner from '../../../../../components/Loaders/Spinner';
import Alert from '../../../../../components/Alert';

const AddEmailNitification = ({ error, success, access, open, type, item, isLoading, isLoadingSubmit, onSubmit, onDelete, onResend, onHide }) => {
  let popoverRef = useRef(null);
  const formNode = useRef(null);

  const [checkedOptions, setCheckedOptions] = useState([]);

  const onSubmitForm = (event) => {
    event?.preventDefault();
    const current = formNode?.current;
    const data = new FormData(current);
    const payload = {};
    for (const name of data.keys()) {
      if (formNode.current?.[name]) {
        payload[name] = formNode.current[name].value;
      }
    }
    const parsePayload = qs.parse(payload);
    parsePayload.notifications = {};
    item?.options?.forEach((item) => {
      if (checkedOptions.includes(item.id)) {
        parsePayload.notifications[item.id] = true;
      } else {
        parsePayload.notifications[item.id] = false;
      }
    });
    onSubmit?.(item?.mode, parsePayload);
  };

  const onDeleteItem = () => {
    popoverRef?.handleHide();
    onDelete?.();
  };

  useEffect(() => {
    if (type === 'add') {
      setCheckedOptions([]);
    }
    if (type === 'edit' && item?.enabled_settings) {
      setCheckedOptions(Object.keys(item?.enabled_settings)?.map(Number));
    }
  }, [item, type]);

  const popover = (
    <Popover id="popover-trigger-click-root-close" title="" className="text-center">
      <Button bsStyle="primary" bsSize="sm" onClick={onDeleteItem}>
        Delete
      </Button>
      <Button bsSize="sm" className="ml-8" onClick={() => popoverRef?.handleHide()}>
        Cancel
      </Button>
    </Popover>
  );

  return (
    <Modal show={open} onHide={onHide} backdrop="static" className="modal-md-custom">
      <form ref={formNode} onSubmit={onSubmitForm}>
        <Modal.Header closeButton>
          <Modal.Title>{type === 'add' ? 'Add staff' : 'Edit staff'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {error && <Alert text={error} />}
          {success && <Alert type="success" text={success} />}
          {isLoading ? (
            <div className="modal-loader-small" />
          ) : (
            <>
              <FormGroup>
                <ControlLabel htmlFor="email">Email</ControlLabel>
                <FormControl type="text" name="email" id="email" defaultValue={item?.email || ''} disabled={type === 'edit'} autoFocus />
                {type === 'edit' && access?.notifications_staff_resend_confirmation ? (
                  <Button bsStyle="link" className="p-0" role="button" onClick={onResend}>
                    Resend confirmation email
                  </Button>
                ) : null}
              </FormGroup>
              <FormGroup>
                <ControlLabel htmlFor="notifications">Notifications</ControlLabel>
                <div className="switch__wrapper">
                  {item?.options?.map((option) => (
                    <div
                      key={option.id}
                      className={classNames('switch__item', {
                        checked: checkedOptions?.includes(option.id),
                      })}
                    >
                      <div className="form-group__switch">
                        <label htmlFor={option.name} className="form-group__switch-label">
                          {option.name}
                        </label>
                        <label className="form-group__switch-form">
                          <input
                            type="checkbox"
                            id={option.name}
                            checked={checkedOptions?.includes(option.id)}
                            value={option.id}
                            onChange={() => setCheckedOptions((prev) => {
                              if (checkedOptions?.includes(option.id)) {
                                return prev?.filter((s) => s !== option.id);
                              }
                              return [...prev, option.id];
                            })}
                          />
                          <span className="slider-form round" />
                        </label>
                      </div>
                    </div>
                  ))}
                </div>
              </FormGroup>
            </>
          )}
        </Modal.Body>
        <Modal.Footer className="custom__modal-footer">
          <Button bsStyle="primary" type="submit" disabled={isLoadingSubmit || isLoading} onClick={onSubmitForm}>
            {isLoadingSubmit && <Spinner />}
            <span>Save changes</span>
          </Button>
          <Button
            onClick={() => {
              onHide();
            }}
          >
            Cancel
          </Button>
          {type === 'edit' && access?.notifications_staff_email_delete ? (
            <div className="pull-right" style={{ position: 'relative' }}>
              <OverlayTrigger ref={(r) => (popoverRef = r)} trigger="click" rootClose placement="top" overlay={popover}>
                <Button bsStyle="link" className="modal-delete-btn">
                  <span>Delete</span>
                </Button>
              </OverlayTrigger>
            </div>
          ) : null}
        </Modal.Footer>
      </form>
    </Modal>
  );
};

AddEmailNitification.propTypes = {
  error: PropTypes.string,
  success: PropTypes.string,
  access: PropTypes.object,
  open: PropTypes.bool,
  type: PropTypes.string,
  item: PropTypes.object,
  isLoading: PropTypes.bool,
  isLoadingSubmit: PropTypes.bool,
  onHide: PropTypes.func,
  onDelete: PropTypes.func,
  onResend: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default AddEmailNitification;
